// extracted by mini-css-extract-plugin
export default {"fixCarriageContainer":"fixCarriage_fixCarriageContainer__Z5TFE"};